import { loadForms } from './load-forms';
export const actions = {
  loadForms
};